export enum TextColor {
  Danger = 'text-danger',
  Dark = 'text-dark',
  Gray500 = 'text-gray-500',
  Info = 'text-info',
  Muted = 'text-muted',
  Success = 'text-success'
}
